import { render, staticRenderFns } from "./loginChoose.vue?vue&type=template&id=4f9f541e&scoped=true&"
import script from "./loginChoose.vue?vue&type=script&lang=js&"
export * from "./loginChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f541e",
  null
  
)

export default component.exports